import { render, staticRenderFns } from "./SkinSensitivity.vue?vue&type=template&id=18522b9d"
import script from "./SkinSensitivity.vue?vue&type=script&lang=js"
export * from "./SkinSensitivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports